// extracted by mini-css-extract-plugin
module.exports = {"list":"_4cdf82c"};